<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> DUPLICAR PEDIDO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form
        ref="form"
        class="compact-form"
        v-model="valid"
        :lazy-validation="lazy"
      >
        <v-container fluid>
          <alert
            :visible="!!showAlert"
            dark
            :type="typeAlert"
            :message="alertMessage"
            :clickClose="() => (showAlert = false)"
          />
          <v-row>
            <v-col cols="12" xs="6" md="3">
              <v-autocomplete
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="company"
                label="Franqueado"
                :disabled="companySessionSelected.id !== ''"
                hide-details
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-text-field
                outlined
                dense
                hide-details
                label="Número Pedido"
                v-model="code"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-btn
                @click="getOrder()"
                color="blue darken-3"
                small
                class="mt-1 white--text"
              >
                <v-icon left> mdi-magnify </v-icon>
                Procurar
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card elevation="0">
                <v-card-text v-if="order.id === ''" style="min-height: 400px">
                  <v-alert
                    dense
                    outlined
                    type="warning"
                    v-if="showNotFoundOrder"
                  >
                    Pedido não encontrado <strong>Pedido Número: </strong>
                    {{ code }}
                  </v-alert>
                </v-card-text>
                <v-card-text v-if="order.id !== ''">
                  <BodyOrderView
                    :order="order"
                    :products="products"
                    :getNameStatusOrder="getNameStatusOrder"
                    :getStrongClassObservation="getStrongClassObservation"
                    :getIconColor="getIconColor"
                    :getSumQuantity="getSumQuantity"
                    :getTotal="getTotal"
                    :address_delivery="address_delivery"
                    :address="address"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      class="pa-0 mx-auto mb-10"
                      style="max-width: 1100px"
                    >
                      <v-btn
                        color="green darken-3"
                        class="float-right white--text"
                        larger
                        outlined
                        :disabled="order.id == ''"
                        @click="showDuplicateOrder()"
                      >
                        <v-icon left> mdi-content-duplicate </v-icon>
                        Duplicar Pedido
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="linkDownload"
    >
      <v-card>
        <v-card-text class="pa-10">
          <v-btn
            class="ma-5 white--text justify-center d-flex"
            large
            color="indigo"
            target="_blank"
            :href="download.link"
            @click="() => (linkDownload = false)"
          >
            <v-icon left>mdi-cloud-download</v-icon>
            CLIQUE AQUI PARA BAIXAR
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="linkDownload = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="500" persistent v-model="dialogDuplicate">
      <v-card>
        <v-card-title class="text-h5 white--text green darken-3">
          Duplicar Pedido
        </v-card-title>
        <v-card-text class="pa-10">
          <p>
            Ao duplicar o Pedido será gerado um novo pedido em
            <strong>Manutenção</strong> com a data de hoje e com os preços dos
            produtos atualizados.
          </p>
          <br />
          <p>Deseja Duplicar para qual empresa?</p>
          <v-autocomplete
            :items="companies"
            :item-text="(item) => `${item.code} - ${item.name}`"
            item-value="id"
            v-model="companyDuplicate"
            label="Empresa"
            hide-details
            dense
            outlined
          ></v-autocomplete>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="handleDuplicateOrder()">
            <v-icon left> mdi-content-duplicate </v-icon>
            Duplicar
          </v-btn>
          <v-btn color="gray" text @click="dialogDuplicate = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="1400"
      width="80%"
      persistent
      retain-focus
      scrollable
      v-model="dialogSelectOrder"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Selecione o pedido para continuar
        </v-card-title>
        <v-card-text class="pa-10">
          <v-row>
            <v-col>
              <v-radio-group v-model="orderSelected">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th></th>
                        <th class="text-left">Código</th>
                        <th class="text-left">Data</th>
                        <th class="text-left">Situação</th>
                        <th class="text-left">Fornecedor</th>
                        <th class="text-right">Produtos</th>
                        <th class="text-right">Itens</th>
                        <th class="text-right">Valor</th>
                        <th class="text-center">Pedido Importado SPF?</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(order, index) in ordersSearchView"
                        :key="order.order.id"
                      >
                        <td>
                          <v-radio :value="index"></v-radio>
                        </td>
                        <td>
                          {{ order.order.franchise_code }}
                          {{ order.order.code }}
                        </td>
                        <td>
                          {{ order.order.issuance_date | dateFormatBr }}
                        </td>
                        <td>{{ getNameStatusOrder(order.order.status) }}</td>
                        <td>
                          {{ order.order.provider_code }} -
                          {{ order.order.provider_name }}
                        </td>
                        <td class="text-right">
                          {{ order.order.products.length }}
                        </td>
                        <td class="text-right">
                          {{ order.order.quantity_items }}
                        </td>
                        <td class="text-right">
                          {{ order.order.value | currencyEuaToBr }}
                        </td>
                        <td class="text-center">
                          {{ order.order.order_imported == 1 ? "Sim" : "Não" }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmDialogSelectOrder()">
            Confirmar
          </v-btn>
          <!-- <v-btn color="" text @click="cancelDialogSelectOrder()">
            Fechar
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";
import { getStatusName } from "@/helpers/order_status";

import Alert from "@/components/Alert";
import BodyOrderView from "@/components/Order/BodyOrderView";
import * as HTTP from "@/api/requests/base";

export default {
  components: {
    Alert,
    BodyOrderView,
  },
  directives: {},
  data: () => ({
    company: "",
    companyDuplicate: "",
    companies: [],
    code: "",
    order: {
      id: "",
    },
    products: [],
    address: "",
    address_delivery: "",
    loading: false,
    lazy: false,
    valid: true,
    showNotFoundOrder: false,
    showAlert: false,
    alertMessage: "",
    typeAlert: "",
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
    urlprint: "#",
    dialogDuplicate: false,
    companySessionSelected: {
      id: "",
    },
    dialogSelectOrder: false,
    ordersSearchView: [],
    orderSelected: "",
    useData: {},
  }),
  computed: {},
  created() {
    let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
    if (session) {
      session = JSON.parse(session);
      if (session.user !== "") {
        this.userData = session.user;
      }
      if (
        session.company_selected !== "" &&
        session.company_selected !== undefined
      ) {
        this.companySessionSelected = session.company_selected;
        this.company = this.companySessionSelected.id;
      }
      this.initialize();
    } else {
      this.initialize();
    }
  },
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  methods: {
    async initialize() {
      this.getCompanies();
    },
    async getCompanies() {
      this.loading = true;
      try {
        let url = "?type=fra,mul";
        if (this.companySessionSelected.id !== "") {
          url = `${url}&user=${this.userData.id}`;
        }
        let data = await CompanyAPI.getAll(url);
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getOrder() {
      if (this.company == "" || this.company == null) {
        this.alertMessage =
          "Selecione um Franqueado para poder buscar o Pedido";
        this.typeAlert = "error";
        this.showAlert = true;
        return false;
      }

      if (this.code == "" || this.code == null) {
        this.alertMessage =
          "Preencha o número do pedido para poder buscar o Pedido";
        this.typeAlert = "error";
        this.showAlert = true;
        return false;
      }

      this.loading = true;
      this.order = {
        id: "",
      };
      this.products = [];
      this.showNotFoundOrder = false;
      this.showAlert = false;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}order/view`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            franchise: this.company,
            code: this.code,
          }),
        });
        res = await res.json();
        console.log(res);
        if (res.data.length == 0) {
          this.showNotFoundOrder = true;
          this.order = {
            id: "",
          };
          this.products = [];
        } else {
          if (res.data.length > 1) {
            this.ordersSearchView = res.data;
            this.dialogSelectOrder = true;
            this.orderSelected = "";
          } else {
            this.order = res.data[0].order;
            this.address = res.data[0].address;
            this.address_delivery = res.data[0].address_delivery;
            this.products = res.data[0].dados;
            this.products = Object.keys(this.products).map((key) => ({
              ...this.products[key],
              items: this.products[key].items.sort((a, b) =>
                a.reference < b.reference ? -1 : 1
              ),
            }));
            this.order.observation = JSON.parse(this.order.observation);
            this.order.observation_provider = JSON.parse(
              this.order.observation_provider
            );
            this.urlprint = this.getUrlPrint(this.order.id);
          }
          // this.order = res.data.order;
          // this.address = res.data.address;
          // this.address_delivery = res.data.address_delivery;
          // this.products = res.data.dados;
          // this.order.observation = JSON.parse(this.order.observation);
          // this.order.observation_provider = JSON.parse(
          //   this.order.observation_provider
          // );
          // console.log(res.data.order.id);
          // this.urlprint = this.getUrlPrint(res.data.order.id);
          // console.log(this.urlprint);
        }
        console.log(this.order);
      } catch (error) {
        this.alertMessage =
          "Houve um problema ao buscar os dados do pedido, tente novamente mais tarde";
        this.typeAlert = "error";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    getUrlPrint(id) {
      return `${URL}order/print/${id}`;
    },
    async edit() {
      this.goToCheckoutOrder(this.order);
      // this.$router.push({ path: `/pedidos/checkout/${this.order.id}` });
    },
    async post(data) {
      this.loading = true;
      this.successSave = false;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}performance-indicator`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (res) {
          let response = await res.json();
          console.log(response);
          this.successSave = true;
        } else {
          throw new Error(res.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async exportPdf() {
      this.download = {
        name: "",
        link: "#",
      };
      this.linkDownload = false;
      let data = {};
      data.companies = this.companies.map((item) => ({
        ...item,
        pairs: parseInt(item.pairs),
        accessories: parseInt(item.accessories),
        conservation_products: parseInt(item.conservation_products),
        stock: parseInt(item.stock),
        billing: item.billing,
        national_percent: parseFloat(this.getNationalPercent(item)),
      }));
      data.month = this.month;
      data.year = this.year;

      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}performance-indicator/export/pdf`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        console.log(response);
        this.download.name = response.nome;
        this.download.link = `${URL}performance-indicator/download/${response.nome}`;
        this.linkDownload = true;
      } catch (error) {
        console.log(error);
      }
    },
    // getStatusOrder(status) {
    //   let arr_status = [
    //     {
    //       status: "draft",
    //       name: "Rascunho",
    //     },
    //     {
    //       status: "maintenance",
    //       name: "Em Manutenção",
    //     },
    //     {
    //       status: "sent_franchisor",
    //       name: "Enviado para Franqueador",
    //     },
    //     {
    //       status: "review_franchisor",
    //       name: "Pedido em Análise",
    //     },
    //     {
    //       status: "refused_franchisor",
    //       name: "Pedido Recusado",
    //     },
    //     {
    //       status: "validated_franchisor",
    //       name: "Pedido Validado",
    //     },
    //     {
    //       status: "confirmed_supplier",
    //       name: "Pedido Confirmado",
    //     },
    //     {
    //       status: "refused_supplier",
    //       name: "Pedido Recusado",
    //     },
    //     {
    //       status: "invoiced_supplier",
    //       name: "Pedido Faturado",
    //     },
    //   ];
    //   let status_selected = arr_status.find((item) => item.status === status);
    //   return status_selected.name;
    // },
    getSumQuantity() {
      return Object.keys(this.products)
        .map((id) =>
          this.products[id].items
            .map((item) => item.quantity)
            .reduce((prev, curr) => prev + curr, 0)
        )
        .reduce((prev, curr) => prev + curr, 0);
    },
    getTotal() {
      return Object.keys(this.products)
        .map((id) =>
          this.products[id].items
            .map((item) => item.total)
            .reduce((prev, curr) => prev + curr, 0)
        )
        .reduce((prev, curr) => prev + curr, 0);
    },
    getIconColor(item) {
      if (item.type === "all") {
        return "green";
      } else if (item.type === "company") {
        return "red lighten-1";
      }
      return "yellow darken-2";
    },
    getStrongClassObservation(type) {
      if (type === "company" || type === "type-company") {
        return "font-weight-black";
      }
      return "";
    },
    showDuplicateOrder() {
      this.companyDuplicate = this.company;
      this.dialogDuplicate = true;
    },
    async handleDuplicateOrder() {
      let data = {
        company_id: this.company,
        transfer_to: this.companyDuplicate,
        order_id: this.order.id,
      };
      console.log(data);
      this.loading = true;
      this.successSave = false;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}order/duplicate`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (res) {
          let response = await res.json();
          this.goToCheckoutOrder(response.order);
          // this.$router.push({
          //   path: `/pedidos/checkout/${response.order.id}`,
          // });
          // this.$router.push({ name: "Ncm" });
          console.log(response);
          this.successSave = true;
        } else {
          throw new Error(res.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
        this.dialogDuplicate = false;
      }
    },
    goToCheckoutOrder(order) {
      console.log(order);
      switch (order.status) {
        case "sent_franchisor":
        case "review_franchisor":
          this.$router.push({
            path: `/pedidos/franqueadora/editar/${order.id}`,
          });
          break;
        case "maintenance":
        case "draft":
          this.$router.push({ path: `/pedidos/checkout/${order.id}` });
          break;
        default:
          alert(
            `Não é possível modificar um pedido com o status: ${this.getNameStatusOrder(
              order.status
            )}`
          );
          break;
      }
      // this.$router.push({ path: `/pedidos/checkout/${this.order.id}` });
    },
    getNameStatusOrder(status) {
      return getStatusName(status);
    },
    confirmDialogSelectOrder() {
      if (this.orderSelected === "") {
        alert("Selecione um pedido para poder continuar");
        return false;
      }
      this.dialogSelectOrder = false;

      let orderSelectedDialog = this.ordersSearchView[this.orderSelected];

      this.order = orderSelectedDialog.order;
      this.address = orderSelectedDialog.address;
      this.address_delivery = orderSelectedDialog.address_delivery;
      this.products = orderSelectedDialog.dados;
      this.products = Object.keys(this.products).map((key) => ({
        ...this.products[key],
        items: this.products[key].items.sort((a, b) =>
          a.reference < b.reference ? -1 : 1
        ),
      }));
      this.order.observation = JSON.parse(this.order.observation);
      this.order.observation_provider = JSON.parse(
        this.order.observation_provider
      );
    },
    cancelDialogSelectOrder() {},
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
#styled-input {
  height: 40px;
  font-size: 20pt;
}
.compact-form .fs-12 {
  transform: scale(0.8);
  transform-origin: left;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
.border-right-table {
  border-right: 1px solid #ccc;
}
.none-border-bottom {
  border-bottom: 0px !important;
}
.order-by-products {
  width: 180px;
}
.box-grid {
  background-color: #010101;
  color: white;
  padding: 6px;
  margin: 4px;
  width: 30px;
  height: 30px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
}
.box-quantity {
  background-color: #dfdfdf;
  color: black;
  padding: 6px;
  margin: 4px;
  width: 30px;
  height: 30px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
}
</style>
